import { useMemo } from 'react';

import { UserTypeEnum } from '@/types/schema';

import useUsers from '../../../../UsersSearch/hooks/useUsers';
import { UseVisibilitySettingsReturnType } from './useVisibilitySettings';

const useVisibilitySettingsUsers = (props: Pick<UseVisibilitySettingsReturnType, 'values'>) => {
  const {
    values: { userIds },
  } = props;

  const { data: users } = useUsers({
    ids: userIds,
    pause: !userIds?.length,
    userTypes: [UserTypeEnum.Learner],
  });

  const resolvedUsers = useMemo(() => {
    if (!userIds?.length || !users?.length) {
      return [];
    }

    return users;
  }, [userIds, users]);

  return { users: resolvedUsers };
};

export default useVisibilitySettingsUsers;
